import React from "react";
import { Modal } from "react-bootstrap";
import postsuccess from "../../images/password-restored.svg";
import { Link } from "react-router-dom";

const AttractionAddedSuccess = (props) => {
  return (
    <Modal
      className="publshedpost-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton></Modal.Header> */}
      <Modal.Body>
        <div className="post-success-body">
          {props.edit === true ? (
            <h2>Your attraction has been updated</h2>
          ) : (
            <h2>Great! You have published {props?.name}!</h2>
          )}
          <div className="modal-image">
            <img src={postsuccess} alt="published post image" />
          </div>
          <div className="dashboard-btn">
            <Link to="/attractions" className="button">
              Ok
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AttractionAddedSuccess;
